// extracted by mini-css-extract-plugin
module.exports = {"carousel":"carousel_carousel__1kW5u","content":"carousel_content__1risj","control":"carousel_control__T8TqV"};